import { Button, Modal } from 'antd'
import React from 'react'

interface DiscardChangesModalProps {
  open: boolean
  onKeepEditing: () => void
  onDiscard: () => void
}

export const DiscardChangesModal: React.FC<DiscardChangesModalProps> = ({
  open,
  onKeepEditing,
  onDiscard,
}) => (
  <Modal
    open={open}
    title="Discard changes?"
    onCancel={onKeepEditing}
    maskClosable={false}
    destroyOnClose
    footer={[
      <Button key="keep" onClick={onKeepEditing}>
        Keep editing
      </Button>,
      <Button key="discard" type="primary" danger onClick={onDiscard}>
        Discard
      </Button>,
    ]}
  >
    You have unsaved changes. If you leave now, your changes will be lost.
  </Modal>
)
